import { tripsTabSagaWatcher, unloadingTripsTabSagaWatcher } from './containers/TripsTabContainer/services/saga';
import { cellSettingsSagaWatcher } from './containers/DirectorSettings/service/saga';
import { smcCarsSagaWatcher } from './containers/SMCcars/services/saga';
import { ResourcesSagaWatcher } from './containers/Resources/services/saga';

export const directorModuleSaga = [
  tripsTabSagaWatcher,
  unloadingTripsTabSagaWatcher,
  cellSettingsSagaWatcher,
  smcCarsSagaWatcher,
  ResourcesSagaWatcher,
];
